
import {computed, defineComponent, PropType, ref, toRef} from "vue";
import Multiselect from "@vueform/multiselect";
import axios from "axios";
import {v4 as uuidv4} from "uuid";
import Text from "@/Components/Utilities/Text.vue";
import Label from "@/Components/Utilities/Label.vue";
import FieldError from "@/Components/Utilities/FieldError.vue";
import Description from "@/Components/Utilities/Description.vue";
import {isEmpty} from "lodash";
import route from "ziggy-js";
import User from "@/types/User";

interface Props {
  label: string;
  modelValue: string | number | any[];
  options: User[] | null;
  routeName: string | null;
  required: boolean;
  disabled: boolean;
  placeholder: string;
  id?: string;
  description: string;
  errorMessage: string;
}

export default defineComponent({
  props: {
    mode: {
      type: String,
      required: false,
      default: () => "tags",
      validator: (value: string) => {
        return ["single", "multiple", "tags"].indexOf(value) !== -1;
      },
    },
    label: {
      type: String,
      required: false,
      default: () => "",
    },
    description: {
      type: String,
      required: false,
      default: "",
    },
    errorMessage: {
      type: String,
      required: false,
      default: "",
    },
    modelValue: {
      type: [String, Number, Array],
      required: false,
      default: () => [],
    },
    options: {
      type: [Array, Object] as PropType<User[]>,
      required: false,
      default: () => [],
    },
    routeName: {
      type: String,
      required: false,
      default: null,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    id: {
      type: String,
      required: false,
      default: null,
    },
    size: {
      type: String,
      required: false,
      default: "sm",
    },
  },
  emits: ["update:modelValue"],
  components: {
    Multiselect,
    Text,
    Label,
    FieldError,
    Description,
  },
  setup(props: Props, {emit}) {
    const id = toRef(props, "id");
    const modelValue = toRef(props, "modelValue");
    const options = toRef(props, "options");
    const routeName = toRef(props, "routeName");
    const apiErrorMessage = ref<string | null>(null);
    const multiselectRef = ref<any>(null);
    const valueProp = "value";

    const multiselectPropOptions = (
        !options.value
            ? []
            : options.value

    ).map((option: User) => {
      return {value: option.id, label: option.firstname + " " + option.lastname};
    });

    async function getOptions(query: string = ''): Promise<{ label: string, value: any }[]> {
      try {
        apiErrorMessage.value = null;
        console.log(query)


        if (!routeName.value) {
          if (!query && isEmpty(modelValue.value)) {
            return multiselectPropOptions;
          } else {
            if (query) {


              let clientFiltered = multiselectPropOptions.filter((option) => {
                const lowercaseLabel = option.label.toLowerCase();
                const lowercaseSearchTerm = query.toLowerCase();
                return lowercaseLabel.includes(lowercaseSearchTerm);
              });
              console.log(clientFiltered)
              return clientFiltered;
            } else {
              return multiselectPropOptions;
            }
          }

        }

        const result = await axios.get(
            route(routeName.value, {
              search: query ?? "",
              id: modelValue.value ? (modelValue.value as any) : "",
            })
        );

        return result.data.users.map((option: User) => {
          return {value: option.id, label: option.firstname + " " + option.lastname};
        });
      } catch (e: any) {
        if (e.message) {
          apiErrorMessage.value = e.message;
        } else {
          apiErrorMessage.value = "Noe gikk galt";
        }
        return [];
      }
    }


    const computedId = computed((): any => {
      return id && id.value ? id.value : uuidv4();
    });

    const onChange = (value: any) => {
      emit("update:modelValue", value);
    };

    function addFirstFromSearch() {
      const query = multiselectRef.value.search as string;
      const options = multiselectRef.value.filteredOptions as {
        [key: string]: any;
      }[];

      if (query && query.trim() !== "" && options.length > 0) {
        const selectedVal = multiselectRef.value.pointer
            ? multiselectRef.value.pointer[valueProp]
            : options[0][valueProp];

        multiselectRef.value.select(selectedVal);
      }
    }

    return {
      onChange,
      apiErrorMessage,
      multiselectPropOptions,
      getOptions,
      computedId,
      addFirstFromSearch,
      multiselectRef,
      valueProp,
    };
  },
});
